import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import tinycolor from 'tinycolor2';
import * as BrowserUtils from '../utils/BrowserUtils';
import {getImageUrl} from '../utils/ApiUtils';
import {ImagePropType} from '../utils/ApiPropTypes';

export default class TransitionRedirect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false
    };
  }

  componentDidMount() {
    this.setState({
      isMobile: BrowserUtils.isMobile.any()
    });
  }

  render() {
    const {cancelButtonText, backgroundImage, backgroundVideo} = this.props;
    const {isMobile} = this.state;
    const backgroundImageUrl = getImageUrl(backgroundImage);

    let backgroundStyle = null;
    if (backgroundVideo && !isMobile) {
      backgroundStyle = {
        backgroundImage: 'none',
        overflow: 'hidden'
      };
    } else if (backgroundImageUrl && (!backgroundVideo || isMobile)) {
      backgroundStyle = {
        background: `url(${backgroundImageUrl}) center center fixed`,
        backgroundSize: 'cover'
      };
    }

    return (
      <div className="vuCardRedirect" style={backgroundStyle}>
        {
          this.renderBackgroundVideo()
        }
        <div className="vuCardRedirect__content">
          {
            this.renderHeader()
          }
          {
            this.renderLoading()
          }
          <div className="vuCardRedirect__cancel">
            {
              this.setCustomStylesForCancelButton()
            }
            <button className="vuCardRedirect__cancel__button"
                    onClick={this.props.onCancel.bind(this)}
                    dangerouslySetInnerHTML={{__html: cancelButtonText || 'CHANGE PROVIDER'}} />
          </div>
        </div>
      </div>
    );
  }

  setCustomStylesForCancelButton() {
    const {cancelButtonColor} = this.props;

    if (cancelButtonColor) {
      const color = tinycolor(cancelButtonColor);

      return (
        <style dangerouslySetInnerHTML={{
          __html: `
.vuCardRedirect__cancel__button {
  background-color: ${cancelButtonColor};
}

.vuCardRedirect__cancel__button:hover, .vuCardRedirect__cancel__button:active, .vuCardRedirect__cancel__button:focus {
        background-color: ${color.darken(10).toString()};
}

.vuCardRedirect__cancel__button::after {
        background-color: ${color.darken(10).toString()};
}`
        }} />
      );
    }
  }

  renderHeader() {
    const {network, destination, transitionToText, transitionOnText} = this.props;

    return (
      <div className="vuCardRedirect__header">
        {
          (!network || network.name === destination.name) ?
            <span>
              <span className="vuCardRedirect__header__text"
                    dangerouslySetInnerHTML={{__html: transitionToText || 'Now transporting you to'}}/>
              <img className="vuCardRedirect__header__destinationImage"
                   alt={destination.name}
                   src={destination.transitionImageUrl}/>
            </span>
            :
            null
        }
        {
          (network && network.name !== destination.name) ?
            <span>
              <span className="vuCardRedirect__header__text"
                    dangerouslySetInnerHTML={{__html: transitionToText || 'Now transporting you to'}}/>
              <img className="vuCardRedirect__header__networkImage"
                   alt={network.name}
                   src={network.transitionImageUrl}/>
              <span className="vuCardRedirect__header__text"
                    dangerouslySetInnerHTML={{__html: transitionOnText || 'on'}}/>
              <img className="vuCardRedirect__header__destinationImage"
                   alt={destination.name}
                   src={destination.transitionImageUrl}/>
            </span>
            :
            null
        }
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="vuCardRedirect__loading">
        {
          _.times(4, (i) => {
            return (
              <img className="vuCardRedirect__loading__dot"
                   src="/static/vupulse-logo-arrow.svg"
                   key={i}/>);
          })
        }
      </div>
    );
  }

  renderBackgroundVideo() {
    if (this.props.backgroundVideo && !this.state.isMobile) {
      return (
        <video className="vuCardRedirect__backgroundVideo"
               preload="metadata"
               style={{
                 height: 'auto',
                 width: 'auto',
                 minHeight: '100%',
                 minWidth: '100%',
                 position: 'absolute',
                 top: '50%',
                 left: '50%',
                 transform: 'translate(-50%, -50%)',
                 zIndex: -100,
                 transition: '1s opacity'
               }}
               src={this.props.backgroundVideo}
               playsinline
               autoPlay
               muted
               loop/>
      );
    }
  }
}

TransitionRedirect.propTypes = {
  network: PropTypes.shape({
    name: PropTypes.string.isRequired,
    transitionImageUrl: PropTypes.string.isRequired,
  }),
  destination: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    transitionImageUrl: PropTypes.string.isRequired,
  }).isRequired,
  transitionToText: PropTypes.string,
  transitionOnText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  cancelButtonColor: PropTypes.string,
  backgroundImage: ImagePropType,
  backgroundVideo: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};


TransitionRedirect.defaultProps = {
  transitionToText: 'Now transporting you to',
  transitionOnText: 'on',
  cancelButtonText: 'CHANGE PROVIDER',
};
